import _extends from "@babel/runtime/helpers/extends";
var _responsiveSpacingNon;
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { spacingClasses } from './globalSpacing.js';
import { spacing40, spacing50, layout10, layout20, spacingInsetTall30, spacingInsetTall40, spacingInsetTall50 } from '../styles/tokens';
var commonMobileStyles = {
  display: 'grid',
  padding: spacing40,
  gridGap: layout10
};
var responsiveSpacingNoneStyles = (_responsiveSpacingNon = {}, _responsiveSpacingNon["&." + spacingClasses.SPACING_ROW_NONE_CLASS_NAME] = {
  gridRowGap: 0,
  paddingTop: 0,
  paddingBottom: 0
}, _responsiveSpacingNon["&." + spacingClasses.SPACING_COLUMN_NONE_CLASS_NAME] = {
  gridColumnGap: 0,
  paddingLeft: 0,
  paddingRight: 0
}, _responsiveSpacingNon);
var useStyles = makeStyles(function (theme) {
  var _theme$breakpoints$up, _ref, _theme$breakpoints$up2, _extends2, _theme$breakpoints$be, _theme$breakpoints$up3, _extends3, _ref2, _extends4, _ref3, _global;
  return {
    '@global': (_global = {}, _global["." + spacingClasses.RESET_SPACING_CLASS_NAME] = (_ref = {
      padding: '0',
      margin: '0'
    }, _ref["&." + spacingClasses.RESET_SPACING_RIGHT_LEFT_STANDARD_CLASS_NAME] = {
      marginLeft: "-" + spacing40,
      marginRight: "-" + spacing40
    }, _ref["&." + spacingClasses.RESET_SPACING_ALL_STANDARD_CLASS_NAME] = {
      margin: "-" + spacing40
    }, _ref[theme.breakpoints.up('lg')] = (_theme$breakpoints$up = {}, _theme$breakpoints$up["&." + spacingClasses.RESET_SPACING_RIGHT_LEFT_STANDARD_CLASS_NAME] = {
      marginLeft: "-" + spacing50,
      marginRight: "-" + spacing50
    }, _theme$breakpoints$up["&." + spacingClasses.RESET_SPACING_ALL_STANDARD_CLASS_NAME] = {
      margin: "-" + spacing50
    }, _theme$breakpoints$up), _ref), _global["html body ." + spacingClasses.OUTER_SPACING_NONE_CLASS_NAME] = {
      padding: '0 !important'
    }, _global["." + spacingClasses.SPACING_NONE_CLASS_NAME] = {
      display: 'grid',
      padding: 0,
      margin: 0,
      gridGap: 0
    }, _global["html ." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = _extends({}, commonMobileStyles), _global["." + spacingClasses.SPACING_RESPONSIVE_CLASS_NAME] = (_ref2 = {}, _ref2["&." + spacingClasses.CONTAINER_CLASS_NAME] = _extends((_extends2 = {}, _extends2[theme.breakpoints.up('lg')] = (_theme$breakpoints$up2 = {}, _theme$breakpoints$up2["&." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = {
      padding: spacing50,
      gridGap: layout20
    }, _theme$breakpoints$up2), _extends2), responsiveSpacingNoneStyles), _ref2["&." + spacingClasses.TEMPLATE_CLASS_NAME] = _extends((_extends3 = {
      padding: spacingInsetTall30,
      gridGap: layout20
    }, _extends3[theme.breakpoints.between('sm', 'lg')] = (_theme$breakpoints$be = {}, _theme$breakpoints$be["&." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = {
      padding: spacingInsetTall40,
      gridGap: layout20
    }, _theme$breakpoints$be), _extends3[theme.breakpoints.up('lg')] = (_theme$breakpoints$up3 = {}, _theme$breakpoints$up3["." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = {
      padding: spacingInsetTall50,
      gridGap: layout20
    }, _theme$breakpoints$up3), _extends3), responsiveSpacingNoneStyles), _ref2), _global["." + spacingClasses.LAYOUT_CLASS_NAME] = _extends((_extends4 = {}, _extends4["&." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = {
      padding: 0,
      gridGap: layout20
    }, _extends4), responsiveSpacingNoneStyles), _global["." + spacingClasses.SPACING_NON_RESPONSIVE_CLASS_NAME] = (_ref3 = {}, _ref3["&." + spacingClasses.SPACING_STANDARD_CLASS_NAME] = {
      padding: spacing50,
      gridGap: layout20
    }, _ref3), _global)
  };
}, {
  index: 2
});
function CssGlobalSpacing(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children;
  useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}
CssGlobalSpacing.propTypes = {
  /**
   * You can wrap a node.
   */
  children: PropTypes.node
};
export default CssGlobalSpacing;